import { render, staticRenderFns } from "./ProposalList.vue?vue&type=template&id=56941d8c&scoped=true"
import script from "./ProposalList.vue?vue&type=script&lang=ts"
export * from "./ProposalList.vue?vue&type=script&lang=ts"
import style0 from "./ProposalList.vue?vue&type=style&index=0&id=56941d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56941d8c",
  null
  
)

export default component.exports